/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { StoreManagementCategoryItemRequest } from '../models/StoreManagementCategoryItemRequest';
import type { StoreManagementCategoryItemResponseApiRespoonse } from '../models/StoreManagementCategoryItemResponseApiRespoonse';
import type { StoreManagementCreateItemRequest } from '../models/StoreManagementCreateItemRequest';
import type { StoreManagementCreateItemResponseApiRespoonse } from '../models/StoreManagementCreateItemResponseApiRespoonse';
import type { StoreManagementCreateSaleRequest } from '../models/StoreManagementCreateSaleRequest';
import type { StoreManagementCreateSaleResponseApiRespoonse } from '../models/StoreManagementCreateSaleResponseApiRespoonse';
import type { StoreManagementDeleteItemRequest } from '../models/StoreManagementDeleteItemRequest';
import type { StoreManagementDeleteItemResponseApiRespoonse } from '../models/StoreManagementDeleteItemResponseApiRespoonse';
import type { StoreManagementEditItemRequest } from '../models/StoreManagementEditItemRequest';
import type { StoreManagementEditItemResponseApiRespoonse } from '../models/StoreManagementEditItemResponseApiRespoonse';
import type { StoreManagementExportItemRequest } from '../models/StoreManagementExportItemRequest';
import type { StoreManagementExportItemResponseApiRespoonse } from '../models/StoreManagementExportItemResponseApiRespoonse';
import type { StoreManagementImportItemRequest } from '../models/StoreManagementImportItemRequest';
import type { StoreManagementImportItemResponseApiRespoonse } from '../models/StoreManagementImportItemResponseApiRespoonse';
import type { StoreManagementListEditItemRequest } from '../models/StoreManagementListEditItemRequest';
import type { StoreManagementListEditItemResponseApiRespoonse } from '../models/StoreManagementListEditItemResponseApiRespoonse';
import type { StoreManagementListItemRequest } from '../models/StoreManagementListItemRequest';
import type { StoreManagementListItemResponseApiRespoonse } from '../models/StoreManagementListItemResponseApiRespoonse';
import type { StoreManagementListSaleRequest } from '../models/StoreManagementListSaleRequest';
import type { StoreManagementListSaleResponseApiRespoonse } from '../models/StoreManagementListSaleResponseApiRespoonse';
import type { StoreManagementPreviewItemRequest } from '../models/StoreManagementPreviewItemRequest';
import type { StoreManagementPreviewItemResponseApiRespoonse } from '../models/StoreManagementPreviewItemResponseApiRespoonse';
import type { StoreManagementSyncItemRequest } from '../models/StoreManagementSyncItemRequest';
import type { StoreManagementSyncItemResponseApiRespoonse } from '../models/StoreManagementSyncItemResponseApiRespoonse';
import type { StoreManagementViewItemRequest } from '../models/StoreManagementViewItemRequest';
import type { StoreManagementViewItemResponseApiRespoonse } from '../models/StoreManagementViewItemResponseApiRespoonse';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class StoreManagementStoreService {

    /**
     * ストア商品一覧
     * @param requestBody
     * @returns StoreManagementListItemResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static adminStore(
        requestBody: StoreManagementListItemRequest,
    ): CancelablePromise<StoreManagementListItemResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/store',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

    /**
     * ストア商品の新規登録
     * @param requestBody
     * @returns StoreManagementCreateItemResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static adminStoreCreate(
        requestBody: StoreManagementCreateItemRequest,
    ): CancelablePromise<StoreManagementCreateItemResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/store/create',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

    /**
     * ストア商品の新規登録
     * @param requestBody
     * @returns StoreManagementViewItemResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static adminStoreView(
        requestBody: StoreManagementViewItemRequest,
    ): CancelablePromise<StoreManagementViewItemResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/store/view',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

    /**
     * ストア商品の更新
     * @param requestBody
     * @returns StoreManagementEditItemResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static adminStoreEdit(
        requestBody: StoreManagementEditItemRequest,
    ): CancelablePromise<StoreManagementEditItemResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/admin/store/edit',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

    /**
     * ストア商品の削除
     * @param requestBody
     * @returns StoreManagementDeleteItemResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static adminStoreDelete(
        requestBody: StoreManagementDeleteItemRequest,
    ): CancelablePromise<StoreManagementDeleteItemResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/admin/store/delete',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

    /**
     * ストア商品プレビュー
     * @param requestBody
     * @returns StoreManagementPreviewItemResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static adminStorePreview(
        requestBody: StoreManagementPreviewItemRequest,
    ): CancelablePromise<StoreManagementPreviewItemResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/store/preview',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

    /**
     * リストの更新
     * @param requestBody
     * @returns StoreManagementListEditItemResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static adminStoreListEdit(
        requestBody: StoreManagementListEditItemRequest,
    ): CancelablePromise<StoreManagementListEditItemResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/store/list-edit',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

    /**
     * セール期間の新規登録
     * @param requestBody
     * @returns StoreManagementCreateSaleResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static adminStoreSale(
        requestBody: StoreManagementCreateSaleRequest,
    ): CancelablePromise<StoreManagementCreateSaleResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/store/sale',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

    /**
     * セール情報一覧
     * @param requestBody
     * @returns StoreManagementListSaleResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static adminStoreListSale(
        requestBody: StoreManagementListSaleRequest,
    ): CancelablePromise<StoreManagementListSaleResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/store/list-sale',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

    /**
     * Export csv
     * @param requestBody
     * @returns StoreManagementExportItemResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static adminStoreExport(
        requestBody: StoreManagementExportItemRequest,
    ): CancelablePromise<StoreManagementExportItemResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/store/export',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

    /**
     * Import Csv
     * @param requestBody
     * @returns StoreManagementImportItemResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static adminStoreImport(
        requestBody: StoreManagementImportItemRequest,
    ): CancelablePromise<StoreManagementImportItemResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/store/import',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

    /**
     * ストア商品カテゴリ別一覧
     * @param requestBody
     * @returns StoreManagementCategoryItemResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static adminStoreListSort(
        requestBody: StoreManagementCategoryItemRequest,
    ): CancelablePromise<StoreManagementCategoryItemResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/store/list-sort',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

    /**
     * ストア商品表示順更新
     * @param requestBody
     * @returns StoreManagementSyncItemResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static adminStoreSync(
        requestBody: StoreManagementSyncItemRequest,
    ): CancelablePromise<StoreManagementSyncItemResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/store/sync',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

}
